import { render, staticRenderFns } from "./UsersPrivilegeActivities.vue?vue&type=template&id=0e50304f&scoped=true&"
import script from "./UsersPrivilegeActivities.vue?vue&type=script&lang=js&"
export * from "./UsersPrivilegeActivities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e50304f",
  null
  
)

export default component.exports